import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button, Stack, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { styled } from '@mui/material/styles'
import dayjs from 'dayjs';
import { LEAD_ORDER_PAYMENT_STATUS, LEAD_ORDER_STATUS, convertMoney, getOrderId } from '../../../../utils/utils';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const CourseItem = ({ order }) => {
  const history = useHistory()

  const openDetail = () => {
    history.push(`/crm/lead/${order.user.username}/${order.lead}`)
  }

  console.log({order})
  return (
    <StyledTableRow
      key={order.id}
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
    >
      <TableCell onClick={openDetail} align="right" style={{ cursor: 'pointer', color: 'blue', textDecorationLine: 'underline' }}>{getOrderId(order.id)}</TableCell>
      <TableCell>{dayjs(order.order_date).format('HH:mm DD/MM/YYYY')}</TableCell>
      <TableCell align="right">{`${order.user.full_name}`}<br /><a href={`/crm/contact/${order.user.username}`}>{order.user.username}</a></TableCell>
      <TableCell align="right">{order?.serviceName ?? order?.service?.name}</TableCell>
      <TableCell align="right">{order?.lead_order ? getOrderId(order?.lead_order) : ''}</TableCell>
      <TableCell align="right">{convertMoney(order.price)}</TableCell>
      <TableCell align="right">{order.completed_booking}</TableCell>
      <TableCell align="right">{order.number_of_booking}</TableCell>
      <TableCell align="right">{order?.support_user?.full_name}</TableCell>
      <TableCell align="right">{order?.sale1?.full_name}</TableCell>
      <TableCell align="right">{order?.sale2?.full_name}</TableCell>
      <TableCell align="right">{order?.telesale?.full_name}</TableCell>
    </StyledTableRow>
  )
}

export default CourseItem